<template>
  <div class="container mt-2 mb-2">
      <div class="row">
        <div class="col-8">
          <h1>Haben Sie eine neue Wohnung gefunden?</h1>
          <h5>Hier können Sie das Mietangebot vorab selbst prüfen.</h5>
          <p>
            Bitte beachten Sie, dass Ihr Mietangebot maximal für einen 7 Personen Haushalt geprüft werden kann.<br>
            Ab einem <span class="fw-bold">8 Personen</span> Haushalt ist eine individuelle Prüfung durch das Jobcenter erforderlich.<br>
            Bei Anmietung eines Zimmers in einer <span class="fw-bold">Wohngemeinschaft</span> muss vom Jobcenter eine <span class="fw-bold">Einzelfallprüfung</span> durchgeführt
            werden.
          </p>
        </div>
        <div class="col-4">
          <img class="img-fluid" src="../assets/jobcenter_logo.jpg" />
        </div>
      </div>


  <form @submit.prevent="handleSubmit">
    <div class="mb-3">
    <label class="form-label">Personenzahl:<span class="invalid">*</span></label>
    <input type="number" class="form-control" v-model.trim="state.persons">
    <span class="invalid" v-if="v$.persons.$error">
      {{ v$.persons.$errors[0].$message }}
    </span>
    </div>

    <div class="mb-3">
    <label class="form-label">Wohnfläche in m²:</label>
    <input type="text" class="form-control" v-model.trim="state.space">
    <span class="invalid" v-if="v$.space.$error">
      {{ v$.space.$errors[0].$message }}
    </span>
    </div>

    <div class="mb-3">
    <label class="form-label">Kaltmiete ohne Nebenkosten (inkl. ggf. Kosten f. Möblierung) in €:<span class="invalid">*</span></label>
    <input type="text" class="form-control" v-model.trim="state.coldRentWithoutNk">
    <span class="invalid" v-if="v$.coldRentWithoutNk.$error">
      {{ v$.coldRentWithoutNk.$errors[0].$message }}
    </span>
    </div>

    <div class="mb-3">
    <label class="form-label">Nebenkosten ohne Heizkosten in €:<span class="invalid">*</span></label>
    <input type="text" class="form-control" v-model.trim="state.coldRentWithoutHeatingCost">
    <span class="invalid" v-if="v$.coldRentWithoutHeatingCost.$error">
      {{ v$.coldRentWithoutHeatingCost.$errors[0].$message }}
    </span>
    </div>

    <div class="mb-3">
    <label class="form-label">Kosten für Stellplatz/ Garage in €:</label>
    <input type="text" class="form-control" v-model.trim="state.garageCost">
    <span class="invalid" v-if="v$.garageCost.$error">
      {{ v$.garageCost.$errors[0].$message }}
    </span>
      <div id="garageCostHint" class="form-text">(falls Anmietung zwingend erforderlich, bitte vom Vermieter bestätigen lassen.)</div>
    </div>

    <div class="mb-3">
      <label class="form-label">
        Liegt für das Gebäude ein Energie<span class="fw-bold">bedarfs</span>ausweis mit einem Wert von maximal 100 Kilowattstunden je m² pro Jahr
        vor?*
      </label>
      <br>
    <input type="checkbox" class="form-check-input" v-model="state.energy">
    <label class="form-check-label">Ja</label>
      <div id="energyHint" class="form-text">* Falls ja fügen Sie bitte bei der Prüfung des Mietangebotes durch das Jobcenter eine Kopie des
        Energiebedarfsausweises bei.</div>
    </div>
    <h6>Die Prüfung ist nur für den Wohnraum in Münster gültig.</h6>
    <div class="cq-rent-calculator-submit">
      <button class="btn btn-primary">Vorabprüfung jetzt durchführen</button>
    </div>
  </form>
  </div>
    <div class="container mt-4">
    <div class="row">
      <div class="col-4 text-center">
        <a href="https://www.stadt-muenster.de/jobcenter/index">Startseite</a>
      </div>
      <div class="col-4 text-center">
        <a href="https://www.stadt-muenster.de/jobcenter/impressum">Impressum</a>
      </div>
      <div class="col-4 text-center">
        <a href="https://www.stadt-muenster.de/jobcenter/datenschutz">Datenschutz</a>
      </div>
    </div>
  </div>

</template>

<script>
import useVuelidate from '@vuelidate/core'
import {required, helpers} from '@vuelidate/validators'
import {reactive, computed} from "vue"

export default {
  name: 'Calculate-Form',
  setup() {
    const state = reactive({
      persons: '',
      space: '',
      coldRentWithoutNk: '',
      coldRentWithoutHeatingCost: '',
      garageCost: '',
      energy: false
    })

    const mustBeFormat = helpers.regex(/^\d+(,\d{1,2})?$/)
    const mustBePersonsValue = helpers.regex(/^([1-7])$/)

    const rules = computed(() => {
      return {
        persons: {
          required: helpers.withMessage('Bitte geben Sie eine Personenzahl ein!', required),
          mustBePersonsValue: helpers.withMessage('Bitte geben Sie eine Zahl zwischen 1 und 7 ein!', mustBePersonsValue)
        },
        space: {
          mustBeFormat: helpers.withMessage('Bitte geben Sie die Wohlfläche in geeigneter Form ein! (Beispiel: 80,09 oder 100)', mustBeFormat)
        },
        coldRentWithoutNk: {
          required: helpers.withMessage('Bitte geben Sie eine Kaltmiete ohne Nebenkosten ein!', required),
          mustBeFormat: helpers.withMessage('Bitte geben Sie einen Betrag ein! (Beispiel: 125,70 oder 100)', mustBeFormat)
        },
        coldRentWithoutHeatingCost: {
          required: helpers.withMessage('Bitte geben Sie die Nebenkosten ohne Heizkosten ein!', required),
          mustBeFormat: helpers.withMessage('Bitte geben Sie einen Betrag ein! (Beispiel: 125,70 oder 100)', mustBeFormat)
        },
        garageCost: {mustBeFormat: helpers.withMessage('Bitte geben Sie einen Betrag ein! (Beispiel: 125,70 oder 100)', mustBeFormat)}
      }
    })

    const v$ = useVuelidate(rules, state)

    return {
      state,
      v$
    }
  },
  methods: {
    handleSubmit() {
      this.v$.$validate();
      if (!this.v$.$error) {
        this.$store.commit("setAuthentication", true);
        this.$store.commit("setPersons", this.state.persons);
        this.$store.commit("setSpace", this.state.space);
        this.$store.commit("setColdRentWithoutNk", this.state.coldRentWithoutNk);
        this.$store.commit("setColdRentWithoutHeatingCost", this.state.coldRentWithoutHeatingCost);
        this.$store.commit("setGarageCost", this.state.garageCost);
        this.$store.commit("setEnergy", this.state.energy);
        this.$router.replace({name: "result"});
      }
    }
  }
}
</script>

<style>
span.invalid {
  color: red;
}
</style>